import React, {useCallback, useState} from 'react';
import { api } from '../../api';
import LoginForm from "./components/LoginForm";
import styled from "styled-components";
import CreateAccountForm from "./components/CreateAccountForm";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import {connect} from "react-redux";


const OuterContainer = styled.div`
  padding-bottom: 40px;
  color: white;
`;

const AuthPage = ({loginError, showLoadingModal, toggleLoadingModal, login}) => {
  const [showCreateAccount, setShowCreateAccount] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotPasswordErr, setForgotPasswordErr] = useState({});
  const [registerErr, setRegisterErr] = useState({});

  const resetPassword = useCallback(async (payload) => {
    setForgotPasswordErr({});
    try {
      toggleLoadingModal(true);
      await api.post('apiauth/v1/password_reset/', payload);
      toggleLoadingModal(false);
      alert("Password reset email has been sent to " + payload.email + ".");
    } catch (e) {
      setForgotPasswordErr(e.response.data);
      toggleLoadingModal(false);
    }
  }, [])

  const register = useCallback(async (payload) => {
    toggleLoadingModal(true);
    try {
      const res = await api.post('triniq_ticket/v1/register_user/', payload);
      await login({
        email: payload.email,
        password: payload.password
      });
    } catch (e) {
      setRegisterErr(e.response.data)
    }
    toggleLoadingModal(false);
  }, [])

  if (showForgotPassword) {
    return (
      <OuterContainer>
        <ForgotPasswordForm
          handleSubmit={resetPassword}
          onClickLogin={() => setShowForgotPassword(false)}
          onChange={() => setForgotPasswordErr({})}
          errors={forgotPasswordErr}
        />
      </OuterContainer>
    )
  }

  return (
    <OuterContainer>
      {showCreateAccount ?
        <CreateAccountForm
          onSubmit={register}
          onClose={() => setShowCreateAccount(false)}
          onChange={(name, value) => setRegisterErr({[name]: []})}
          errors={registerErr}
          isLoading={showLoadingModal}
        /> :
        <LoginForm
          loginError={loginError}
          login={login}
          resetPassword={() => setShowForgotPassword(true)}
          onClose={() => setShowCreateAccount(true)}
          isLoading={showLoadingModal}
        />
      }
    </OuterContainer>
  );
}


const mapState = state => {
  return {
    loginError: state.auth.loginError,
    showLoadingModal: state.ticket.showLoadingModal,
    isLoggedIn: state.auth.isLoggedIn,
  }
}

const mapDispatch = dispatch => ({
  whoAmI: dispatch.auth.whoAmI,
  login: dispatch.auth.login,
  logout: dispatch.auth.logout,
  // resetPassword: dispatch.auth.resetPassword,
  toggleLoadingModal: dispatch.ticket.toggleLoadingModal,
})

export default connect(mapState, mapDispatch)(AuthPage);